import { TooltipRenderProps } from '@dreryk/react-charts';
import { TranslatableText } from '@dreryk/react-common';
import { StyledFlex } from '@dreryk/react-components';

import { StyledTooltipCard } from './TooltipCard.styled';
import { TooltipCardInfoBlock } from './TooltipCardInfoBlock';

type TooltipCardProps = {
   readonly data: TooltipRenderProps;
   readonly label: TranslatableText;
};

export const TooltipCard = (props: TooltipCardProps): JSX.Element => {
   const { data, label } = props;

   const difference = (data.points[0].data.y as number) - (data.points[1].data.y as number);

   return (
      <StyledTooltipCard cardType='modal'>
         <StyledFlex direction='column' gap={8}>
            <TooltipCardInfoBlock
               count={data.points[0].data.y.toString()}
               date={data.points[0].data.x as Date}
               difference={difference}
               label={label}
            />
            <TooltipCardInfoBlock
               count={data.points[1].data.y.toString()}
               date={data.points[1].data.x as Date}
               label={label}
            />
         </StyledFlex>
      </StyledTooltipCard>
   );
};
